import { Phone, Mail, MapPin, Instagram, Facebook, MessageCircle } from "lucide-react";
import { Reveal, GMark } from "@/components/Reveal";
import LeadForm from "@/components/landing/LeadForm";

export default function Footer({ onWhatsapp }) {
  return (
    <>
      {/* Final lead capture */}
      <section id="contato" className="relative overflow-hidden py-24 sm:py-32 bg-background">
        <GMark className="h-[400px] -right-16 top-10 rotate-6" opacity={0.05} />
        <div className="relative max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <p className="overline text-primary mb-4">Fale com a gente</p>
            <h2 className="font-display font-bold text-4xl sm:text-6xl tracking-tighter text-secondary leading-[0.95]">
              Peça seu orçamento <span className="text-primary italic font-light">gratuito</span>
            </h2>
            <p className="mt-5 text-muted-foreground leading-relaxed max-w-md">
              Sem compromisso. Nossa equipe analisa seu consumo e apresenta a economia exata para o seu caso.
            </p>
            <div className="mt-8 space-y-3 text-secondary">
              <a href="tel:+5575988623979" className="flex items-center gap-3 hover:text-primary transition-colors"><Phone size={18} className="text-primary" /> (75) 98862-3979</a>
              <p className="flex items-center gap-3"><Mail size={18} className="text-primary" /> contato@greenera.com.br</p>
              <p className="flex items-center gap-3"><MapPin size={18} className="text-primary" /> Feira de Santana • Petrolina • Juazeiro</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-3xl bg-surface border border-border/60 p-6 sm:p-8 shadow-xl shadow-secondary/5">
              <LeadForm testPrefix="lead-contato" />
            </div>
          </Reveal>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-secondary text-secondary-foreground relative grain overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10 relative">
          <div className="lg:col-span-2">
            <div className="mb-5">
              <img src="/logo-transparent.png" alt="Green Era Energia" className="h-16 sm:h-20 w-auto drop-shadow-[0_2px_14px_rgba(255,255,255,0.12)]" />
            </div>
            <p className="text-secondary-foreground/60 max-w-sm leading-relaxed">
              Energia limpa, economia real. Projetos solares para residências e empresas em toda a região da Bahia e Pernambuco.
            </p>
            <div className="flex gap-3 mt-6">
              {[Instagram, Facebook, MessageCircle].map((Ic, i) => (
                <button key={i} onClick={i === 2 ? onWhatsapp : undefined} className="grid place-items-center w-10 h-10 rounded-full bg-white/10 hover:bg-primary transition-colors" data-testid={`social-${i}`}>
                  <Ic size={18} />
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="overline text-accent mb-4">Navegação</p>
            <ul className="space-y-2 text-secondary-foreground/70">
              {[["beneficios", "Benefícios"], ["simulador", "Simulador"], ["solucoes", "Soluções"], ["faq", "FAQ"]].map(([id, label]) => (
                <li key={id}><button onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })} className="hover:text-primary transition-colors">{label}</button></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="overline text-accent mb-4">Contato</p>
            <ul className="space-y-2 text-secondary-foreground/70">
              <li>(75) 98862-3979</li>
              <li>contato@greenera.com.br</li>
              <li>Feira de Santana, BA</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-sm text-secondary-foreground/50">
            <p>© {new Date().getFullYear()} Green Era Energia Solar. Todos os direitos reservados.</p>
            <a href="/admin/login" className="hover:text-primary transition-colors" data-testid="admin-link">Área do administrador</a>
          </div>
        </div>
      </footer>
    </>
  );
}
